module.exports = __webpack_public_path__ + "img/icon_mine_nor.b478162d.png";